import { Action, Dispatch } from 'redux'
import { initCampaignsAction } from 'reducks/campaign/actions'

const initCampaigns = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initCampaignsAction())
  }
}

export default initCampaigns
